import React from 'react';
import { bookingUrl } from '../data/site';
export function MobileBookingBar() {
  return <div className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-white/95 p-3 backdrop-blur sm:hidden" data-id="element-93" data-mp="1uh2x364tkg11">
      <a href={bookingUrl} className="block rounded-full bg-sage py-3.5 text-center font-bold text-white transition-colors duration-150 active:bg-sage-dark" data-id="element-94" data-mp="28gm23q2c3b94">
        Réserver un soin
      </a>
    </div>;
}